import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";

type Props = {
  percentage: number;
};

export const PercentageChangeIndicator = ({ percentage }: Props) => {
  const normalizedPercentage = Math.abs(percentage) < 0.000001 ? 0 : percentage; // Convert very small numbers to 0, avoid "-0" values
  const formattedPercentage = `${normalizedPercentage.toFixed(1)}%`;

  if (percentage < -10) {
    return (
      <>
        (
        <KeyboardDoubleArrowDownIcon
          sx={({ palette }) => ({ color: palette.error.main })}
        />
        {formattedPercentage})
      </>
    );
  }

  if (percentage < -0.0001) {
    return (
      <>
        (
        <KeyboardArrowDownIcon
          sx={({ palette }) => ({ color: palette.error.main })}
        />
        {formattedPercentage})
      </>
    );
  }

  //very small numbers, practically 0
  if (percentage > -0.0001 && percentage < 0.0001) {
    return <>({formattedPercentage})</>;
  }

  if (percentage < 10) {
    return (
      <>
        (
        <KeyboardArrowUpIcon
          sx={({ palette }) => ({ color: palette.success.main })}
        />
        {formattedPercentage})
      </>
    );
  }

  return (
    <>
      (
      <KeyboardDoubleArrowUpIcon
        sx={({ palette }) => ({ color: palette.success.main })}
      />
      {formattedPercentage})
    </>
  );
};
